import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { photos, faqItems, siteConfig } from '../data/mock';
import { usePageMeta } from '../hooks/use-page-meta';
import { HeroSection } from '../components/home/HeroSection';
import { PortfolioSection } from '../components/home/PortfolioSection';
import { AboutSection } from '../components/home/AboutSection';
import { ServicesSection } from '../components/home/ServicesSection';
import { ProcessSection } from '../components/home/ProcessSection';
import { FAQSection } from '../components/home/FAQSection';
import { CTASection } from '../components/home/CTASection';

export const HomePage = () => {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState(null);

  usePageMeta({
    description: 'Elina K. is a family, newborn, maternity and couples photographer in Dubai. Natural, elegant photo sessions from 1,000 AED with edited photos, a highlight video and a private online gallery.',
    path: '/'
  });

  // Get photos by category
  const outdoorPhotos = photos.filter(p => p.category === 'outdoor');
  const indoorPhotos = photos.filter(p => p.category === 'indoor');
  const studioPhotos = photos.filter(p => p.category === 'studio');

  const handleScrollToPortfolio = () => {
    document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleCategoryClick = (category) => {
    navigate(`/gallery?category=${category}`);
  };

  const handleBookSession = (packageType) => {
    navigate('/contact', { state: { packageType } });
  };

  const handleNavigateToContact = () => {
    navigate('/contact');
  };

  const handleNavigateToGallery = () => {
    navigate('/gallery');
  };

  return (
    <div className="min-h-screen bg-[#1a1a1a]">
      <HeroSection 
        onExplore={handleNavigateToGallery}
        onScrollDown={handleScrollToPortfolio}
      />

      <PortfolioSection 
        outdoorPhotos={outdoorPhotos}
        indoorPhotos={indoorPhotos}
        studioPhotos={studioPhotos}
        onCategoryClick={handleCategoryClick}
      />

      <AboutSection 
        image={siteConfig.aboutImage}
        onBookSession={handleNavigateToContact}
      />

      <ServicesSection 
        onBookSession={handleBookSession}
      />

      <ProcessSection />

      <FAQSection 
        faqItems={faqItems}
        openFaq={openFaq}
        setOpenFaq={setOpenFaq}
      />

      <CTASection 
        onContact={handleNavigateToContact}
      />
    </div>
  );
};
